// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__wj6uq","col":"Table_col__3v6Xu","fulfillmentStatus":"Table_fulfillmentStatus__ORGuR","emailCol":"Table_emailCol__2xKAv"};